import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "down-3-hIi",
  "use": "down-3-hIi-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"down-3-hIi\"><path d=\"M7.021 14L14 6.951l-1.639-1.628-4.202 4.173V0H5.841v9.496L1.639 5.323 0 6.951z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol